import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  Stack
} from '@mui/material';
import { AdminApprovalRequest } from '../../services/payrollService';

interface ApprovalDialogProps {
  open: boolean;
  onClose: () => void;
  onApprove: () => void;
  loading: boolean;
  approvalForm: AdminApprovalRequest;
  onFormChange: (form: AdminApprovalRequest) => void;
}

const ApprovalDialog: React.FC<ApprovalDialogProps> = ({
  open,
  onClose,
  onApprove,
  loading,
  approvalForm,
  onFormChange
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Approve Payroll</DialogTitle>
      <DialogContent>
        <Box sx={{ pt: 2 }}>
          <Stack spacing={3}>
            <TextField
              fullWidth
              multiline
              rows={3}
              label="Approval Notes"
              value={approvalForm.approvalNotes || ''}
              onChange={(e) => onFormChange({ ...approvalForm, approvalNotes: e.target.value })}
            />
          </Stack>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onApprove} variant="contained" disabled={loading}>
          Approve
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ApprovalDialog;
